<ng-template #provisionBulkModalFormContent role="document" let-modal>

  <!-- @if(!embeddedFormMode) {
    <app-modal-comp-header
      [title]="formTitle"
      (cancelButtonOnClick)="closeForm(); modal.dismiss('Cross click')"
    ></app-modal-comp-header>
  } -->
  <div class="row"> 
    <div [className]="embeddedFormMode ? 'col-0' : 'col-0'"></div>
    <div [className]="embeddedFormMode ? 'col-12' : 'col-0'">

      <form (ngSubmit)="saveFormData()" [formGroup]="provisioningBulkForm" class="tablelist-form" autocomplete="off">
        <div class="modal-body">

          <!-- <div class="row">
            <div class="col-12">
              <div class="mb-3">
                <div class="alert alert-progress-info d-flex align-items-center mb-0" [ngClass]="alertColourProgress" role="alert">
                  <i class="alert-progress-info__icon me-2" [ngClass]="alertColourProgress=='alert-danger' ? 'ri-error-warning-fill' : 'ri-information-fill'"></i>
                  <span [innerHtml]="progressInformation"></span>
                </div>
              </div>
            </div>
          </div> -->

          <app-sim-provision-bulk #simProvisionBulkEmbeddedComponent
            [extraGridHeightOffset]   ="embeddedFormMode ? 50 : 0"
            [initialCompanyId]        ="sureSimCompanyId"
            [initialInviewCompanyId]  ="inviewCompanyId"
            [showCancelButton]        ="!embeddedFormMode"
            (bulkProvisionButtonClick)="bulkProvisionButtonClick()"
            (companyIdChanged)        ="onCompanyIdChanged($event)"
            (gridEditRowClick)        ="editOrder($event)"
            (gridOrderLinkClick)      ="orderLinkClick($event)"
            (gridUserLinkClick)       ="userLinkClick($event)"
            (formClosed)              ="closeForm()"
            (viewEmailTemplateClick)  ="openEmailTemplate()"
            (viewSmsTemplateClick)    ="openSmsTemplate()"
          ></app-sim-provision-bulk>

        </div>
      </form>
    </div>
    <div [className]="embeddedFormMode ? 'col-0' : 'col-0'"></div>
  </div>

  <!-- <app-spinner-overlay-wrapper #spinnerOverlayWrapperComponent
    [showSpinner]="this.provisioningInProgress"
  ></app-spinner-overlay-wrapper> -->

</ng-template>

<app-manage-esim-modal-form #manageEsimModalForm
></app-manage-esim-modal-form>

<app-provision-bulk-order-modal-form #bulkOrderEditForm
  [initialCompanyId]="this.sureSimCompanyId"
  [initialInviewCompanyId]="this.inviewCompanyId"
  (bulkOrderFormCancelled)="this.bulkOrderDataHasBeenSaved()"
  (bulkOrderDataHasBeenSaved)="this.bulkOrderDataHasBeenSaved()"
></app-provision-bulk-order-modal-form>

<app-user-modal-form #userModalForm
></app-user-modal-form>

<app-warning-modal-form #warningModalForm
></app-warning-modal-form>

<!--RBW_20260604 - Template modals must live here (in FormsModalModule) to avoid a circular module dependency with PagesEmbeddedModule-->
<app-template-email-modal-form #emailTemplateModalForm
  [bodyOnly]="true"
  title="Email Message"
  updateMessage="Message Updated."
  (emailTemplateModalFormClosed)="emailTemplateModalFormClosed($event)"
></app-template-email-modal-form>

<app-template-sms-modal-form #smsTemplateModalForm
  [bodyOnly]="true"
  title="SMS Message"
  updateMessage="Message Updated."
  (smsTemplateModalFormClosed)="smsTemplateModalFormClosed($event)"
></app-template-sms-modal-form>
